import FileAPI from "../../../../../services/fileAPI"
import { useSingleMinigrid } from "../../../hook"
import GalleryImageView from "./GalleryImageView/GalleryImageView"

export default function GalleryImagePresenter() {
    const {singleMinigridQuery :{isLoading, data}} = useSingleMinigrid()
    if (isLoading) return <div>Loading...</div>
  return (
    <GalleryImageView images ={
      data?.minigrid_tumbnail_url && data?.minigrid_tumbnail_url !== "" ?
      [
        {
            src: FileAPI.getFilesURL(data?.minigrid_tumbnail_url), 
            alt: data?.minigrid_name
        }
    ]: []} />
  )
}
